export const ExpressOrderReceiver = [
    {
        name: 'Имя',
        key: 'name',
    },
    {
        name: 'Телефон',
        key: 'phone_number',
    },
    {
        name: 'Доп. телефон',
        key: 'additional_phone_number',
    },
    {
        name: 'Адрес',
        key: 'building',
    },
    {
        name: 'СТАТУС',
        key: 'statusDescription',
    },
    {
        name: 'ЦЕНА',
        key: 'clientPrice',
    },
]

export const ExpressOrderReceiverItem = [
    {
        name: 'Товар',
        key: 'title',
    },
    {
        name: 'Цена',
        key: 'price',
    },
    {
        name: 'Количество',
        key: 'count',
    },
]

export const ExpressOrderColumns = [
    {
        name: 'Номер накладной',
        key: 'invoice_number',
    },
    {
        name: 'Дата заказа',
        key: 'created_at',
        withHint: true,
    },
    {
        name: 'Компания',
        key: 'company_name',
    },
    {
        name: 'Забор',
        key: 'from_address',
    },
    {
        name: 'Кол-во получателей',
        key: 'receivers_count',
    },
    {
        name: 'Контейнер',
        key: 'container_name',
    },
    {
        name: 'Итого к оплате',
        key: 'price',
        withHint: true,
    },
    {
        name: 'Статус',
        key: 'statusDescription',
    },
]

export const ExpressTariffsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Город',
        key: 'cityName',
    },
    {
        name: 'Тип',
        key: 'typeName',
    },
    {
        name: 'Подача',
        key: 'pricePerServing',
    },
    {
        name: 'Километраж',
        key: 'pricePerKilometer',
    },
    {
        name: 'Вручение',
        key: 'pricePerDelivery',
    },
]
